<template>
  <a-card hoverable :title="item.title" style="width: 330px; height: 310px; cursor: default; margin: 0 auto;">
    <template #extra>
      <a-button id="btn-dl" type="primary" shape="round" :href="item.url" v-if="item.url">
        <template #icon>
          <DownloadOutlined/>
        </template>
      </a-button>
      <a-button id="btn-dl" type="primary" shape="round" v-else-if="item.content" @click="$emit('showModal', item.content)">
        <template #icon>
          <ExpandAltOutlined />
        </template>
      </a-button>
      <a-button type="primary" shape="round" disabled="disabled" v-else>
        Coming Soon
      </a-button>
    </template>

    <div style="margin-bottom: 10px; text-align: center;">
      <a :href="item.url" v-if="item.url">
        <img alt="icon" :src="item.icon" style="height: 128px; cursor: pointer"/>
      </a>
      <a @click="$emit('showModal', item.content)" v-else-if="item.content">
        <img alt="icon" :src="item.icon" style="height: 128px; cursor: pointer"/>
      </a>
      <img alt="icon" :src="item.icon" style="height: 128px; cursor: not-allowed" v-else/>
    </div>
    <a-card-meta :title="item.filename">
      <template #description>{{ item.desc }}</template>
    </a-card-meta>
  </a-card>
</template>

<script>
import {DownloadOutlined, ExpandAltOutlined} from '@ant-design/icons-vue';

export default {
  components: {
    DownloadOutlined,
    ExpandAltOutlined,
  },
  props: ["item"]
}
</script>
